import SeoTags from "../../../seo/SeoTags";
import LeftRail from "../left-rail/LeftRail";
import { useLang } from "../../../i18n/LangContext";
import DesktopMonetizeOverview from "./overview/DesktopMonetizeOverview";
import DesktopMonetizeAdvantages from "./advantages/DesktopMonetizeAdvantages";
import DesktopMonetizeSteps from "./steps/DesktopMonetizeSteps";
import DesktopFooter from "../footer/DesktopFooter";
import GlobeFx from "../../../assets/footer/globe.png";
import GlobeBase from "../../../assets/footer/globe 1.png";
import LogoPNG from "../../../assets/footer/logo-footer.png";
import "./DesktopAppRegisterPublisher.css";

export default function DesktopAppMonetize({ onSelectAdvertiser = () => {}, onContact = () => {} }) {
  const { lang, t } = useLang();
  const isBG = lang === "bg";

  const base = "https://offerwall-web-9dd25471534d.herokuapp.com";
  const url = `${base}/monetize`;
  const canonical = url;
  const locale = isBG ? "bg_BG" : "en_US";

  const title = isBG
    ? "Givvy Offerwall — Монетизирай с Mobile Offerwall SDK"
    : "Givvy Offerwall — Mobile Offerwall SDK";

  const description = isBG
    ? "Леко SDK за offerwall, което се интегрира бързо в Android и iOS и носи надеждни приходи и сигурни плащания."
    : "A lightweight offerwall SDK that integrates fast across Android and iOS to deliver reliable revenue and secure payouts.";

  const sections = [
    { id: "overview", label: t.nav.monetize },
    { id: "advantages", label: t.monetizeAdvantages?.eyebrow || "Advantages" },
    { id: "steps", label: t.monetizeSteps?.eyebrow || "How it works" },
  ];

  return (
    <>
      <SeoTags
        title={title}
        description={description}
        url={url}
        canonical={canonical}
        locale={locale}
        alternates={[{ href: url, hreflang: "x-default" }]}
        image={`${base}/og/og-hero.jpg`}
      />

      <LeftRail
        sections={sections}
        railLeft={100}
        navHeight={88}
        dotSize={16}
        dotsSide="left"
        dotsGap={54}
        dotsVAlign="center"
      />

      <div className="desktop-monetize-area">
        <DesktopMonetizeOverview
          id="overview"
          onGetStarted={onSelectAdvertiser}
          onContact={onContact}
        />

        <DesktopMonetizeAdvantages id="advantages" />

        <DesktopMonetizeSteps id="steps" />

        <DesktopFooter
          logoSrc={LogoPNG}
          globeSrc={GlobeBase}
          globeOverlaySrc={GlobeFx}
          socialLinks={[
            "https://facebook.com/…",
            "https://instagram.com/…",
            "https://youtube.com/…",
            "https://t.me/…",
            "https://x.com/…",
            "https://tiktok.com/@…",
          ]}
        />
      </div>
    </>
  );
}
